import { Link } from 'react-router-dom';
import { dataHome } from '../utils/useData';
import { BoxTextHome } from '../components/layouts/BoxText';

import BottomNav from '../components/layouts/BottomNav';
import Button from '../components/layouts/Button';
import Footer from '../components/layouts/Footer';

import arrowImg from '../images/icons/right-arrow.png';

function Home() {

    return (

        <>

            <div className='container animate__animated animate__fadeIn'>

                <section className='hero_container'>

                    <div className='box_text'>

                        <h1>
                            Oi, eu sou o Lucas, e adoro construir belos sites
                        </h1>

                        <Link to='/portfolio' className='hero_link'>

                            <img src={arrowImg} alt='' />

                            <p>Conheça meu trabalho</p>

                        </Link>

                    </div>

                </section>

                <section className='about_c'>

                    {
                        /*<picture>
                
                            <source media="(min-width: 1080px)"
                                srcSet={} />
                            <source media="(min-width: 701px)"
                                srcSet={} />
                            <source media="(max-width: 700px)"
                                srcSet={} />
                
                            <img className="hero_img" src={`${}`} alt="" />
                
                        </picture>*/
                    }

                    <div id='about' >

                        <BoxTextHome
                            title='Sobre mim'
                            text={dataHome}
                        />

                        <div className='btn_c'>

                            <Button
                                to='/portfolio'
                                text='Veja meu Portfólio'
                            />

                        </div>

                    </div>

                </section>

                <BottomNav />

            </div>

            <Footer />

        </>

    )

}

export default Home;